'use client'

import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import { useWordpressStore } from '@repo/store/useWordpressStore'
import { useEffect, useState } from 'react'
import Carousel from 'react-material-ui-carousel'
import { CarouselNavigation } from '@repo/ui/CarouselNavigation'
import { Logo } from '@repo/ui/Logo'
import PropTypes from 'prop-types'

export const AnnouncementsPanel = ({ width }) => {
  const { dashboardAnnouncements, fetchDashboardAnnouncements } = useWordpressStore()
  const [announcementsIndex, setAnnouncementsIndex] = useState(0)
  const [currentAnnouncement, setCurrentAnnouncement] = useState(null)

  useEffect(() => {
    if (!dashboardAnnouncements?.length) return
    const currentAnnouncement = dashboardAnnouncements[announcementsIndex]
    setCurrentAnnouncement(currentAnnouncement)
  }, [announcementsIndex, setCurrentAnnouncement, dashboardAnnouncements])

  useEffect(() => {
    fetchDashboardAnnouncements()
  }, [fetchDashboardAnnouncements])

  if (!currentAnnouncement) {
    return (
      <MUIStack
        data-testid="AnnouncementsPanel"
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ width: '100%', position: 'relative' }}
      >
        <Logo
          sx={{ width: '512px', height: '416px', opacity: 0.15, position: 'absolute', top: '-200px', right: '-100px' }}
        />
      </MUIStack>
    )
  }

  return (
    <>
      <CarouselNavigation
        index={announcementsIndex}
        onChange={setAnnouncementsIndex}
        items={dashboardAnnouncements}
        showNumbers={false}
        sx={{ position: 'absolute', top: '0px', right: '40px', color: 'white', zIndex: 2 }}
      />
      <MUIStack
        data-testid="AnnouncementsPanel"
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ width, height: '220px' }}
      >
        <Carousel
          animation="slide"
          autoPlay={false}
          data-testid="carousel"
          index={announcementsIndex}
          indicators={false}
          sx={{ width, height: '220px' }}
          navButtonsAlwaysInvisible={true}
          swipe={false}
        >
          {dashboardAnnouncements.map((announcement, index) => (
            <MUIStack
              key={index}
              sx={{ overflow: 'hidden', width, height: '220px' }}
              justifyContent="center"
              direction="row"
              gap={'30px'}
            >
              <MUIStack
                direction="column"
                alignItems="flex-end"
                justifyContent="center"
                sx={{ width: '270px' }}
                gap={1}
              >
                <MUITypography
                  variant="subtitle2"
                  sx={{ color: '#49A4FF', textTransform: 'uppercase', textAlign: 'right', marginBottom: 0 }}
                >
                  {announcement.type}
                </MUITypography>

                <MUITypography variant="h4" sx={{ color: 'white', textAlign: 'right', marginBottom: '4px' }}>
                  {announcement.title}
                </MUITypography>

                <MUITypography
                  variant="body1"
                  sx={{
                    color: 'white',
                    userSelect: 'none',
                    textDecoration: 'underline',
                    textAlign: 'right',
                    cursor: 'pointer',
                    marginBottom: 0
                  }}
                >
                  <a target="_blank" href={announcement.link} style={{ color: 'white' }}>
                    {announcement.linkText}
                  </a>
                </MUITypography>
              </MUIStack>

              <a
                target="_blank"
                href={announcement.link}
                style={{
                  objectFit: 'cover',
                  objectPosition: 'top',
                  marginTop: '40px',
                  width: 'auto',
                  maxWidth: '300px'
                }}
              >
                <img
                  src={announcement.image}
                  width="100%"
                  height="180px"
                  style={{ objectFit: 'cover', objectPosition: 'top' }}
                />
              </a>
            </MUIStack>
          ))}
        </Carousel>
      </MUIStack>
    </>
  )
}

AnnouncementsPanel.propTypes = {
  width: PropTypes.string
}
